import { gql } from '@apollo/client'

export default gql(`
  query listUserDeactivationConfig($project: String) {
    listUserDeactivationConfig( project: $project ) {
      id
      items {
        id
        name
        users
      }
    }
  }
`)
